import { render, staticRenderFns } from "./Well.vue?vue&type=template&id=72655bdf&"
import script from "./Well.vue?vue&type=script&lang=js&"
export * from "./Well.vue?vue&type=script&lang=js&"
import style0 from "./Well.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Well.vue"
export default component.exports